import React from "react";
import { useParams } from "react-router-dom";
import {
  useFetchGetUserDetailQuery,
  useFetchPersonelPeriodsQuery,
  useFetchPersonelRightsQuery,
  useFetchUserForUpdateQuery,
} from "../../store";
import Loading from "../../components/shared/Loading";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import PersonelInfo from "./components/PersonelInfo";
import { personelPermissionColumns } from "./utils/permissionRightColumns";
import { DataGrid } from "@mui/x-data-grid";
import Equipments from "./components/Equipments";

const PersonelDetail = () => {
  let { id } = useParams();
  const [expanded, setExpanded] = React.useState(false);

  const { data, isLoading } = useFetchGetUserDetailQuery(id);
  const { data: userForUpdate } = useFetchUserForUpdateQuery(id, { skip: !id || id === "0" });
  const { data: personelRights, isLoading: rightsLoading } =
    useFetchPersonelRightsQuery(
      { page: 1, limit: 30, period: expanded, userId: id },
      { skip: expanded === false },
      { refetchOnMountOrArgChange: true }
    );
  const { data: periods, isLoading: periodsLoading } =
    useFetchPersonelPeriodsQuery({ userId: id });

  if (isLoading || periodsLoading)
    return <Loading isLoading={isLoading || periodsLoading} />;

  const user = data?.data || {};
  const workingEndDate = userForUpdate?.data?.workingEndDate ?? null;

  return (
    <Box
      sx={{
        maxWidth: 600,
        mx: "auto",
        mt: { xs: 7, sm: 8 },
        px: { xs: 1, sm: 2 },
        py: 4,
      }}
    >
      {/* Profil Kartı */}
      <PersonelInfo user={user} workingEndDate={workingEndDate} />

      {/* Accordion Alanı */}
      {periods?.data.map((period) => (
        <Accordion
          key={period.id}
          expanded={expanded === period.id}
          onChange={() =>
            setExpanded(expanded === period.id ? false : period.id)
          }
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography fontWeight={700} color="primary.main">
              {period.name} Dönemi İzin Hakları
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <DataGrid
              rows={personelRights?.data || []}
              loading={rightsLoading && expanded === period.id}
              disableColumnMenu
              columns={personelPermissionColumns()}
              disableRowSelectionOnClick
              autoHeight
            />
          </AccordionDetails>
        </Accordion>
      ))}

      {/* Zimmet Alanı */}
      <Equipments userId={id} />
    </Box>
  );
};

export default PersonelDetail;
